import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Navbar, Button, OverlayTrigger, Popover} from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import DateTimeSelector from 'components/ui/form/dates/datetime/DateTimeSelector';

import 'style/components/ui/form/dates/datetime/datetime-dropdown.scss';

/** Component to select a month using a dropdown calendar component */
class DateTimeDropdown extends Component {

    static propTypes = {
        value:       PropTypes.object, // The timestamp of the date to show
        title:       PropTypes.string, // The title for the Dropdown
        onChange:    PropTypes.func, // Listener for when the date is changed
        labelButton: PropTypes.string, // The text for the ok button
        startLimit:  PropTypes.number, // Timestamp of the available start limit date
        endLimit:    PropTypes.number, // Timestamp of the available end limit date
        disabled:    PropTypes.bool, // True when should be disabled
        hideDate:    PropTypes.bool, // True when date picker should be hide
        hideTime:    PropTypes.bool, // True when time picker should be hide
        notClean:    PropTypes.bool // True when the value can not be cleaned
    };

    static defaultProps = {
        labelButton: 'Ok',
        disabled:    false,
        notClean:    false,
        hideDate:    false,
        hideTime:    false
    };

    state = {
        value: undefined // The initial date
    };

    /**
     * Init the state and set this to handlers
     */
    componentWillMount() {

        const {value} = this.props;

        this.setState({
            value
        });

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * Update the value of the state when the value of the props is changed
     * @param {Object} nextProps The new props to add to the component
     */
    componentWillReceiveProps(nextProps) {
        const {value} = this.props;

        nextProps.value !== value && this.setState({
            value: nextProps.value
        });
    }

    /**
     * Change the date when a month is clicked also close the overlay
     */
    handleChange() {
        return value => {
            const {hideTime, onChange} = this.props;

            this.setState({
                value
            });

            if (hideTime) {
                this.refs.overlay.hide();
                onChange && onChange(value);
            }
        };
    }

    /**
     * Populate change event and close the overlay
     */
    handleClick() {
        const
            {onChange} = this.props,
            {value} = this.state;

        onChange && onChange(value);

        this.refs.overlay.hide();
    }

    renderControl() {
        const {startLimit, endLimit, hideDate, hideTime, notClean, disabled} = this.props;
        const {value} = this.state;
        const date = value && new Date(value);

        return (
            <div className={`datetime-dropdown-panel-child`} >
                <DateTimeSelector
                    defaultValue={date && date.getTime()}
                    onChange={this.handleChange()}
                    startLimit={startLimit}
                    endLimit={endLimit}
                    hideDate={hideDate}
                    hideTime={hideTime}
                    notClean={notClean}
                    disabled={disabled}
                />
            </div>
        );
    }

    renderOkButton() {
        const {hideTime, labelButton, disabled} = this.props;

        return !hideTime ? (
            <Button
                className="pull-right"
                disabled={disabled}
                onClick={this.handleClick}
            >
                {labelButton}
            </Button>
        ) : null;
    }

    renderPanel() {
        return (
            <div className="datetime-dropdown-panel">
                {this.renderControl()}
                {this.renderOkButton()}
            </div>
        );
    }

    renderDate(date, envelope) {
        const
            {hideDate, hideTime, intl:{formatDate, formatMessage}} = this.props,
            format = {};
        let labelEmpty = 'label.msg_no_time';


        if (!hideDate) {

            labelEmpty = 'label.msg_no_date';
            format.year = 'numeric';
            format.month = 'short';
            format.day = 'numeric';
        }
        if (!hideTime) {
            format.hour = '2-digit';
            format.minute = '2-digit';
        }

        const noDate = { id: labelEmpty };

        return envelope ?
            date ?
                <span>{formatDate(date, format)}</span> :
                <span className="no-date">{formatMessage(noDate)}</span> :
            date ?
                formatDate(date, format) :
                formatMessage(noDate);
    }

    renderText(envelope) {
        const {value} = this.state;

        return this.renderDate(value, envelope);
    }

    render() {
        const {disabled} = this.props;

        return (
            <Navbar.Form className="datetime-dropdown">
                <OverlayTrigger
                    ref="overlay"
                    rootClose
                    trigger="click"
                    placement="bottom"
                    overlay={
                        <Popover
                            id="tooltip"
                            className="datetime-dropdown-popover"
                        >
                            {this.renderPanel()}
                        </Popover>
                    }
                >
                    <Button
                        ref="button"
                        title={this.renderText()}
                        disabled={disabled}
                        onClick={e => { e.stopPropagation() }}
                    >
                        {this.renderText(true)}
                        <span className="caret"/>
                    </Button>
                </OverlayTrigger>
            </Navbar.Form>
        );
    }
}

export default injectIntl(DateTimeDropdown);



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/datetime/DateTimeDropdown.jsx